module.exports = __webpack_public_path__ + "img/jcLogo.53fd304e.png";